module.exports = __webpack_public_path__ + "img/pic-logo-selz.2e8538b0.png";